export default "__VITE_ASSET__SyOr6I0c__"